import { render, staticRenderFns } from "./AgendamentoItem.vue?vue&type=template&id=596c9e58&scoped=true&"
import script from "./AgendamentoItem.vue?vue&type=script&lang=js&"
export * from "./AgendamentoItem.vue?vue&type=script&lang=js&"
import style0 from "./AgendamentoItem.vue?vue&type=style&index=0&id=596c9e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c9e58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VIcon,VListItem,VListItemAction,VListItemAvatar,VListItemContent,VListItemTitle,VTooltip})
